import { ReadMore } from "@genuin/components/molecules/read-more";
import { cn, getTimeAgo } from "@genuin/ui/utils";
import { type ComponentProps } from "react";

import type { PostDetailsType } from "@genuin/components/react-query/api/feed/schema";

import { Pills } from "@genuin/components/molecules/feed-player/pills/pills";
import { OwnerInfo } from "./owner-info";

export type DetailsPropsType = ComponentProps<"div"> & {
  postDetails: PostDetailsType;
  onGroupJoinStatusChange?: ComponentProps<
    typeof Pills
  >["onGroupJoinStatusChange"];
  onGroupSubscriptionChange?: ComponentProps<
    typeof Pills
  >["onGroupSubscriptionChange"];
  onCommunityJoinStatusChange?: ComponentProps<
    typeof Pills
  >["onCommunityJoinStatusChange"];
};

/**
 * This component is used to display the details of a post.
 * It mainly contains the details of owner/community/loop.
 *
 * Create more flavour around this component for mobile view and full screen view.
 * @param param0
 * @returns
 */
export function PostDetails({
  postDetails: { community, owner, video, group },
  className,
  onGroupJoinStatusChange,
  onGroupSubscriptionChange,
  onCommunityJoinStatusChange,
  ...restProps
}: DetailsPropsType) {
  return (
    <div
      className={cn(
        "gencl:border gencl:w-full gencl:border-secondary-150 gencl:p-4 gencl:rounded-2xl",
        className
      )}
      {...restProps}
    >
      <OwnerInfo
        owner={owner}
        createdAt={video.createdAt != null ? getTimeAgo(video.createdAt) : ""}
      />
      {video.description && (
        <ReadMore
          text={video.description}
          maxLines={2}
          textClassName={cn("gencl:text-body-1-medium")}
          className="gencl:pt-3"
        />
      )}
      <Pills
        communityDetails={community}
        groupDetails={group}
        onCommunityJoinStatusChange={onCommunityJoinStatusChange}
        onGroupJoinStatusChange={onGroupJoinStatusChange}
        onGroupSubscriptionChange={onGroupSubscriptionChange}
        isHoverable
        className="gencl:pt-3"
      />
    </div>
  );
}
